import React, {useEffect, useState} from 'react';
import {Grid, Paper} from '@material-ui/core'
import {DashboardHeader} from '../../../components'
import testImage from "../../../assets/images/test.webp";
import './style.scss'
import {AddIcon, emptyStar, starFill} from "../../../assets/images/images";
import axios from "axios";
import {getUserDataFromLocalStorage} from "../../../services/utils";
import {APP_DOMAIN_PREFIX} from "../../../environment";
const d = [2, 2, 2, 2,]
let loginUser = getUserDataFromLocalStorage()
function SavedSearches(props) {
    const [search, setSearch] = useState([])
  const pageName = props.location.pathname;
  console.log(pageName)
  const starHandler = (item) => {
    console.log(item)
  }
  const addNewSearch=()=>{
    props.history.push('newSearch')
  }
    useEffect(() => {
        axios.get(`${APP_DOMAIN_PREFIX}/api/list/${loginUser.ssoId}`).then(res => {
            if (res) {
                setSearch(res.data)
            }
        });
    }, []);
  return (
    <Grid container direction={'column'} className=' p-20 content-main-container'>
      <div className='display-flex align-items-center justify-content-between'>
        <DashboardHeader pageTitle={pageName === '/savedsearch' ? 'saved searches' : 'search results'}/>
        <AddIcon  style={{fontSize:35,}} className='heading-color'  onClick={addNewSearch}/>
      </div>
      <Paper className="mt-20  p-20 display-flex search-container">
        {search.map((item, index) => {
          return (
            <div className='mr-20 '>
                {index + 1}
                 <p className='' style={{textTransform: '',}}>Name :{item.keyword}</p>
                 <p className='' style={{textTransform: '',}}>Price Range :{item.priceRange}</p>
                 <p className='' style={{textTransform: '',}}>Quantity :{item.qty}</p>
                 <p className='' style={{textTransform: '',}}>Quantity Name :{item.qtyName}</p>
                 <p className='' style={{textTransform: '',}}>City :{item.city}</p>
                 <p className='' style={{textTransform: '',}}>Country :{item.country}</p>
            </div>
          )
        })}
      </Paper>
    </Grid>
  );
}

export default SavedSearches;

